module.exports = __webpack_public_path__ + "media/images/android-chrome-192x192-954ecf03736202486c297f9acbab54a8.png";